export enum HTTPStatusCodes {
  NOT_FOUND = 404,
  UNAUTHORIZED = 401,
  BAD_REQUEST = 400,
  REQUEST_TOO_LARGE = 413,
  SERVICE_UNAVAILABLE = 503,
}
